import './index.less';
import React from 'react';
import {connect} from 'react-redux';
import {Layout, notification} from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';

import NavPath from '../../components/NavPath'
import Header from '../../components/Header'
import Sidebar from '../../components/Sidebar'
import Footer from '../../components/Footer'

import { Routes } from '../../routes'

// import Loading from '../../components/Loading'
// import CaseUpload from '../Cases/caseUpload'
import UserProfile from '../User'
import Loading from './Loading'

import { Spin } from 'antd';

const { Content } = Layout;


const mapStateToProps = (state) => {
  return {
    user: state.user,
    errorMessage: state.errorMessage
  }
}


class App extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      needToLogout: false,
      isLoading: true
    }
    this.needToLogoutHandler = this.needToLogoutHandler.bind(this)
  }

  componentWillMount() {
    notification.destroy()
  } 

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.username) {
      this.setState({isLoading:false})
    }
  }

  needToLogoutHandler(data) {
    this.setState({needToLogout:data})
  }

  render() {
    let UserRoutes = Routes
    let username = this.props.user.username
      if (!username) {
        return (
          <Loading needToLogout={this.state.needToLogout}/>
        )
      } else {
      return (
          <Layout className="ant-layout-has-sider">
            <Sidebar accountType={UserRoutes} isLoading={this.state.isLoading}/>
              <Layout>
                <Header needToLogoutHandler={(data) => this.needToLogoutHandler(data)}/>
                <Content style={{ margin: '0 16px' }}>
                  <NavPath/>
                  { UserRoutes && <div style={{ minHeight: 360 }}>
                    <Switch>
                      {UserRoutes.map((route, index) => (
                        <Route key={index} path={route.path} component={route.component} exactly={route.exactly} />
                        ))
                      }
                      <Route path="/profile" component={UserProfile}/>
                      <Redirect to="/home"/>
                    </Switch>
                  </div>}
                </Content>
              <Footer/>
            </Layout>
          </Layout>
        );
      }
    }
  }
export default connect(mapStateToProps)(App);


// WEBPACK FOOTER //
// ./src/views/Layout/index.jsx